import { $host, $authHost, isDev } from './index'
import { httpPoint } from '../utils/const'

export const createOrder = async ({
    type, country, period, count, paymentMethod, countryData, price
}) => {
    const { data } = await $authHost.post(httpPoint.order + 'create', { type, country, period, count, paymentMethod, countryData, price })
    return data
}

export const getAll = async (page, limit) => {
    const { data } = await $authHost.post(httpPoint.order + 'getAll', {page, limit})
    return data
}